<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="fw-bold w-100">
            {{ pageMode() === PageMode.create ? ("help.help_modal.add_step" | translate) : ("help.help_modal.edit_step" | translate) }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body overflow-x-hidden p-3">
        <form class="col-12" [formGroup]="contentEditorForm">
            <div class="bg-card shadow-md rounded p-2 mb-3">
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'help.help_modal.section_titleAE' | translate"
                            formControlName="titleAE"
                            controlName="titleAE"
                            [invalid]="checkInvalid('titleAE')"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'help.help_modal.section_titleEN' | translate"
                            formControlName="titleEN"
                            controlName="titleEN"
                            [invalid]="checkInvalid('titleEN')"
                        ></adaa-form-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12 px-3 my-2">
                        <div class="fw-bold">
                            <p class="form-label mb-0">{{ "help.help_modal.page_content_ae" | translate }}</p>
                        </div>
                        <adaa-quill-editor #contentAE [language]="'ae'" (value)="setValue($event, Language.Arabic)"></adaa-quill-editor>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12 px-3 my-2">
                        <div class="fw-bold">
                            <p class="form-label mb-0">{{ "help.help_modal.page_content_en" | translate }}</p>
                        </div>
                        <adaa-quill-editor #contentEN [language]="'en'" (value)="setValue($event, Language.English)"></adaa-quill-editor>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center">
                        <adaa-form-checkbox
                            [label]="'help.help_modal.section_publish' | translate"
                            [checkboxMode]="'yesNo'"
                            controlName="published"
                            formControlName="published"
                        ></adaa-form-checkbox>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center">
                        <adaa-form-checkbox
                            [label]="'help.help_modal.image_only' | translate"
                            [checkboxMode]="'yesNo'"
                            controlName="imageOnly"
                            formControlName="imageOnly"
                        ></adaa-form-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12 mt-4">
                        <adaa-form-input-file
                            [onDeleteRemoveFile]="false"
                            [allowedFileSize]="199680"
                            [allowedFiles]="fileTypes"
                            [file]="getImage(Language.Arabic)"
                            [label]="imageLabel(Language.Arabic)"
                            (inputChanges)="onFileChange($event, Language.Arabic)"
                        ></adaa-form-input-file>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12 mt-4">
                        <adaa-form-input-file
                            [onDeleteRemoveFile]="false"
                            [allowedFileSize]="199680"
                            [allowedFiles]="fileTypes"
                            [file]="getImage(Language.English)"
                            [label]="imageLabel(Language.English)"
                            (inputChanges)="onFileChange($event, Language.English)"
                        ></adaa-form-input-file>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal=footer d-flex justify-content-center fw-bold mt-3">
        <div class="my-2">
            <adaa-form-action-buttons
                [showSaveButton]="pageMode() !== PageMode.view"
                [saveButtonTitle]="'common.form.button.submit' | translate"
                [cancelButtonTitle]="
                    pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)
                "
                (cancelClicked)="modal.close()"
                (saveClicked)="submit()"
            ></adaa-form-action-buttons>
        </div>
    </div>
</ng-template>
